/**
 * Fetches a PDF file from a URL and converts it to a data URL for display.
 * @param pdfUrl - The URL of the PDF file to fetch
 * @returns A Promise that resolves to a data URL string or undefined if the fetch fails
 */
export async function fetchPdfSrc(pdfUrl: string): Promise<string | null> {
  if (!pdfUrl) return null;

  try {
    const response = await fetch(pdfUrl, { method: 'GET' });
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        resolve(reader.result as string);
      });
      reader.addEventListener('error', reject);
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}
